export const pickupOptions = ['fromShop', 'ourCourier', 'address', 'office'] as const;

export type OurCourierAddress = {
  name: string
  phone: string
  city: 'Варна'
  address: string
  note: string
};

export const courierOption = { ekont: 'ekont', speedy: 'speedy' } as const;

export type CourierAddress = Omit<OurCourierAddress, 'city'> & {
  city: string
  courier: keyof typeof courierOption
};

export type CourierOffice = {
  name: string
  phone: string
  city: string
  office: string
  note: string
  courier: keyof typeof courierOption
};

export type UserAddresses = {
  ourCourier: OurCourierAddress
  courierAddress: CourierAddress
  courierOffice: CourierOffice
};
